import { CHATBOT_COMMANDS } from '~/utils/chat-flags';
import { getPhoneCreditPrepaidTransaction } from '~/api/phone-credit-prepaid';
import { getInvoices } from '~/api/invoices';
import { fetchNeoToggles } from '~/api/neo';

export default {
  methods: {
    /**
     * Check user's data plan prepaid transaction status
     * @command - [apicall] checkDataPlanPrepaidTrxState [/apicall]
     * @param {object} currentTrx - currently selected transaction object
     */
    async checkDataPlanPrepaidTrxState(currentTrx = null) {
      if (!currentTrx) {
        this.$zopim.sendChatMsg(CHATBOT_COMMANDS.responses.noSelectedTransaction);
        return;
      }

      const responses = {
        dataPlanPrepaidTrxState: '[apiresponse] dataPlanPrepaidTrxStateIs<state> [/apiresponse]',
        dataPlanPrepaidTrxStateIsNotProcessedOrSucceededOrRemitted:
          '[apiresponse] dataPlanPrepaidTrxStateIsNotProcessedOrSucceededOrRemitted [/apiresponse]',
        checkDataPlanPrepaidTrxStateIsError: '[apiresponse] checkDataPlanPrepaidTrxStateIsError [/apiresponse]',
        trxWillBeUnstuckAutorefundForProcessed: '[apiresponse] trxWillBeUnstuckAutorefundForProcessed [/apiresponse]',
      };

      try {
        // Get invoice data
        const {
          data: [invoiceData],
        } = await getInvoices(this.$axios, { keywords: currentTrx.paymentId });
        const {
          transactions: [invoiceTrx],
        } = invoiceData;

        const { data: phoneCreditPrepaidData } = await getPhoneCreditPrepaidTransaction(this.$axios, invoiceTrx.id);
        const { state } = phoneCreditPrepaidData;

        const { data = [] } = await fetchNeoToggles(['o2o/autorefund-for-processed-enabled']);
        const isActive = data.find(element => element.id === 'o2o/autorefund-for-processed-enabled')?.active || false;

        if (isActive && state === 'processed') {
          this.$zopim.sendChatMsg(responses.trxWillBeUnstuckAutorefundForProcessed);
          return;
        }

        if (['processed', 'succeeded', 'remitted'].includes(state)) {
          const capitalizedState = state.charAt(0).toUpperCase() + state.slice(1);
          const finalResponse = responses.dataPlanPrepaidTrxState.replace('<state>', capitalizedState);
          this.$zopim.sendChatMsg(finalResponse);
          return;
        }
        this.$zopim.sendChatMsg(responses.dataPlanPrepaidTrxStateIsNotProcessedOrSucceededOrRemitted);
      } catch (error) {
        this.$zopim.sendChatMsg(responses.checkDataPlanPrepaidTrxStateIsError);
        console.error(
          '[ERROR] Something is wrong when trying to check user data plan prepaid transaction state',
          error
        );
      }
    },
  },
};
